import React from 'react'
import classes from './style.module.scss'

export default props => {
	return <a {...props} className={classes.Link}>
		{props.children}
	</a>
}